import { type ServerMessage } from '@soulhx/fs-common';
import React, { useState } from 'react';
import { MaxLengthTextViewer } from '../../../common/ui/MaxLengthTextViewer.js';
import { useTranslation } from 'react-i18next';
import { Alert, Col, Container, Row } from 'react-bootstrap';
import { StandardButton } from '@soulhx/ui-common';
import { useUserSetting } from '@soulhx/client-store';
import { useNavigate } from 'react-router-dom';

interface ISMSnapshotItem {
  sm: ServerMessage;
}
export const SMSnapshotItem = ({ sm }: ISMSnapshotItem) => {
  const { t } = useTranslation(['serverMessages']);
  const [isTrimmed, setIsTrimmed] = useState(false);
  const { update: updateShowMessage } = useUserSetting<boolean>(`helpText.serverMessages.${sm.id}`);
  const navigate = useNavigate();

  return (
    <Alert
      variant={sm.variant || 'info'}
      dismissible={sm.dismissible && !isTrimmed}
      onClose={() => updateShowMessage(false)}
    >
      <Container fluid>
        <Row>
          <Col sm={isTrimmed ? 11 : 12}>
            <MaxLengthTextViewer
              text={t(`serverMessages:${sm.id}`)}
              maxLength={150}
              setDidExceed={(didExceed) => setIsTrimmed(didExceed)}
            />
          </Col>

          {isTrimmed && (
            <Col xs="1">
              <StandardButton type="fullscreen" onClick={() => navigate(`/comms/alert/${sm.id}`)} />
            </Col>
          )}
        </Row>
      </Container>
    </Alert>
  );
};
